var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',[_vm._v(_vm._s(_vm.begin))]),_c('span',{staticClass:"emphasize_text"},[_vm._v(_vm._s(_vm.emphasized))]),_c('span',[_vm._v(_vm._s(_vm.end))])])
}
var staticRenderFns = []

export { render, staticRenderFns }